export default __webpack_public_path__ + "static/media/Border Kingdom Helmet.5d0632ed.jpg";